// URL of a static asset (samples/, fw/). The bundler (tools/build.mjs) sets ASSET_PREFIX when the page is
// served from a deep link or from another folder (the print server serves them under /assets/);
// the unbundled sources use plain relative paths.
export const assetUrl = (path) => (typeof ASSET_PREFIX !== 'undefined' ? ASSET_PREFIX : '') + path;
